/**
 * 繁體中文語言包
 */

export default {
  // 通用
  common: {
    confirm: '確認',
    cancel: '取消',
    save: '保存',
    edit: '編輯',
    delete: '刪除',
    create: '創建',
    update: '更新',
    submit: '提交',
    reset: '重置',
    search: '搜尋',
    filter: '篩選',
    export: '導出',
    import: '導入',
    loading: '載入中...',
    success: '操作成功',
    error: '操作失敗',
    warning: '請注意',
    info: '提示信息',
    noData: '暫無數據',
    networkError: '網路錯誤',
    permissionDenied: '權限不足',
    back: '返回',
    next: '下一步',
    previous: '上一步',
    close: '關閉',
    open: '打開',
    view: '查看',
    download: '下載',
    upload: '上傳'
  },

  // 系統
  system: {
    title: '二維碼報到系統',
    description: '現代化的課程管理和簽到解決方案',
    welcome: '歡迎使用',
    logout: '登出',
    profile: '個人資料',
    settings: '設置',
    help: '幫助',
    about: '關於'
  },

  // 導航
  nav: {
    home: '首頁',
    courses: '課程',
    checkin: '簽到',
    admin: '管理後台',
    dashboard: '儀表板',
    courseManagement: '課程管理',
    studentManagement: '學員管理',
    checkinManagement: '簽到管理',
    analytics: '數據分析',
    settings: '系統設置'
  },

  // 認證
  auth: {
    login: '登錄',
    logout: '登出',
    email: '郵箱地址',
    password: '密碼',
    remember: '記住我',
    forgotPassword: '忘記密碼？',
    loginSuccess: '登錄成功',
    loginFailed: '登錄失敗',
    invalidCredentials: '郵箱或密碼錯誤',
    accountInactive: '帳戶已被禁用',
    permissionInsufficient: '權限不足',
    tokenExpired: '登錄已過期，請重新登錄',
    currentPassword: '當前密碼',
    newPassword: '新密碼',
    confirmPassword: '確認密碼',
    changePassword: '修改密碼',
    passwordChanged: '密碼修改成功'
  },

  // 用戶
  user: {
    name: '姓名',
    email: '郵箱',
    phone: '電話',
    role: '角色',
    status: '狀態',
    admin: '管理員',
    student: '學員',
    active: '活躍',
    inactive: '非活躍',
    createdAt: '創建時間',
    updatedAt: '更新時間',
    lastLogin: '最後登錄',
    profile: '個人資料',
    editProfile: '編輯資料'
  },

  // 課程
  course: {
    title: '課程標題',
    description: '課程描述',
    content: '課程內容',
    price: '價格',
    capacity: '容量',
    status: '狀態',
    draft: '草稿',
    published: '已發布',
    closed: '已關閉',
    modules: '課程模組',
    schedule: '課程安排',
    instructor: '講師',
    duration: '課程時長',
    format: '授課形式',
    online: '線上',
    offline: '實體',
    hybrid: '混合',
    requirements: '參加要求',
    deliverables: '交付成果',
    faq: '常見問題',
    terms: '條款說明',
    register: '立即報名',
    registerNow: '馬上報名',
    applyNow: '申請資格',
    courseList: '課程列表',
    courseDetail: '課程詳情',
    courseManagement: '課程管理',
    createCourse: '創建課程',
    editCourse: '編輯課程',
    publishCourse: '發布課程',
    closeCourse: '關閉課程'
  },

  // 報名
  registration: {
    name: '姓名',
    email: '郵箱地址',
    phone: '聯絡電話',
    position: '職位',
    company: '公司名稱',
    industry: '所屬行業',
    experience: '工作經驗',
    purpose: '參加目的',
    canExecute: '能否執行',
    understandRisk: '理解風險',
    status: '審核狀態',
    pending: '待審核',
    approved: '已通過',
    rejected: '已拒絕',
    registrationForm: '報名表單',
    registrationList: '報名名單',
    registrationDetail: '報名詳情',
    approve: '通過審核',
    reject: '拒絕審核',
    note: '備註',
    registrationSuccess: '報名成功',
    registrationFailed: '報名失敗',
    alreadyRegistered: '您已報名此課程',
    registrationClosed: '報名已截止',
    courseFull: '課程已滿員',
    auditQuestions: '審核問題',
    nextSteps: '下一步說明',
    contactInfo: '聯絡方式'
  },

  // 簽到
  checkin: {
    title: '簽到',
    event: '簽到活動',
    qrCode: '二維碼',
    scanQR: '掃描二維碼',
    checkinTime: '簽到時間',
    location: '簽到地點',
    status: '狀態',
    success: '簽到成功',
    failed: '簽到失敗',
    alreadyCheckedIn: '您已完成簽到',
    invalidQR: '無效的二維碼',
    eventInactive: '簽到活動已停用',
    timeInvalid: '不在簽到時間範圍內',
    createEvent: '創建簽到活動',
    eventList: '簽到活動列表',
    eventDetail: '活動詳情',
    startTime: '開始時間',
    endTime: '結束時間',
    checkinCount: '簽到人數',
    generateQR: '生成二維碼',
    downloadQR: '下載二維碼',
    checkinStats: '簽到統計',
    checkinRecords: '簽到記錄'
  },

  // 統計
  stats: {
    total: '總計',
    count: '數量',
    percentage: '百分比',
    trend: '趨勢',
    overview: '概覽',
    registrationStats: '報名統計',
    checkinStats: '簽到統計',
    courseStats: '課程統計',
    userStats: '用戶統計',
    dailyStats: '每日統計',
    monthlyStats: '月度統計',
    yearlyStats: '年度統計',
    conversionRate: '轉換率',
    growthRate: '增長率'
  },

  // 表單驗證
  validation: {
    required: '此欄位為必填',
    email: '請輸入有效的郵箱地址',
    phone: '請輸入有效的電話號碼',
    minLength: '長度不能少於 {min} 個字符',
    maxLength: '長度不能超過 {max} 個字符',
    passwordMismatch: '兩次輸入的密碼不一致',
    invalidFormat: '格式不正確',
    numberOnly: '只能輸入數字',
    positiveNumber: '必須是正數',
    invalidDate: '日期格式不正確',
    futureDate: '日期不能早於今天',
    pastDate: '日期不能晚於今天'
  },

  // 操作確認
  confirm: {
    delete: '確定要刪除嗎？',
    deleteUser: '確定要刪除此用戶嗎？',
    deleteCourse: '確定要刪除此課程嗎？',
    deleteRegistration: '確定要刪除此報名記錄嗎？',
    approve: '確定要通過審核嗎？',
    reject: '確定要拒絕審核嗎？',
    publish: '確定要發布課程嗎？',
    close: '確定要關閉課程嗎？',
    logout: '確定要登出嗎？',
    unsavedChanges: '有未保存的更改，確定要離開嗎？'
  },

  // 狀態信息
  status: {
    loading: '載入中...',
    saving: '保存中...',
    uploading: '上傳中...',
    processing: '處理中...',
    completed: '已完成',
    failed: '失敗',
    cancelled: '已取消',
    timeout: '操作超時',
    networkError: '網路連接錯誤',
    serverError: '服務器錯誤',
    notFound: '未找到相關數據',
    forbidden: '訪問被拒絕'
  },

  // 分頁
  pagination: {
    total: '共 {total} 條',
    page: '第 {current} 頁，共 {total} 頁',
    itemsPerPage: '每頁顯示',
    goTo: '跳至',
    previous: '上一頁',
    next: '下一頁',
    first: '首頁',
    last: '末頁'
  },

  // 日期時間
  datetime: {
    now: '現在',
    today: '今天',
    yesterday: '昨天',
    tomorrow: '明天',
    thisWeek: '本週',
    thisMonth: '本月',
    thisYear: '今年',
    lastWeek: '上週',
    lastMonth: '上月',
    lastYear: '去年',
    selectDate: '選擇日期',
    selectTime: '選擇時間',
    startDate: '開始日期',
    endDate: '結束日期',
    dateRange: '日期範圍'
  }
}